import React, { useState } from 'react';
import { useSelector } from 'react-redux'
import { createStructuredSelector } from 'reselect';

import ResultCard from './ResultCard';
import {
    getInvestmentResult,
} from '@om/redux/selectors/investmentCalculator/investmentCalculator';
import AssumptionsModal from './AssumptionsModal';

import OmButton from '../forms/OmButton';

const ResultCardSection = ({calculateButtonDisabled, setInvestmentResult}) => {

    const [isAssumptionModalOpen, toggleAssumptionsModal] = useState(false);

    const {
        investmentResult
    } = useSelector(
        createStructuredSelector({
            investmentResult: getInvestmentResult,
        })
    );

    const triggerModal = () => {
        if (isAssumptionModalOpen) {
            toggleAssumptionsModal(false)
            setTimeout(() => toggleAssumptionsModal(true))
        } else {
            toggleAssumptionsModal(true)
        }
    }

    const Notice = () => (
        <p className="assumption-text-notice">
            <a className="view-assumptions" onClick={() => triggerModal()}>View Assumptions </a>
            applied in this calculation. The results should be used as an indication only.
        </p>
    );


    const ResultCardView = ({
        maxInvestmentValue,
        minInvestmentValue,
        isMobile,
        ...rest
    }) => (
        <ResultCard
            currency={'KES '}
            isMobile={isMobile}
            sideIconName="vector_flower"
            maxValTitle="Maximum earnings"
            minValTitle="Minimum earnings"
            moreInfoBlockTitle="Take control of your money"
            moreInfoBlockContent="Now that you know what you could have earned, don’t hesitate, start investing in a"
            moreInfoBlockContentBoldTwo=" Money Market Fund"
            moreInfoBlockButtonText="TELL ME MORE"
            moreInfoBlockButtonIcon="chevron_down"
            calculator="investment-calculator"
            maxInvestmentValue={' ' + investmentResult.maxEarnings}
            minInvestmentValue={' ' + investmentResult.minEarnings}
            calculationResults={investmentResult.message}
            {...rest}
        />
    );

    return (
        <>
            <table slot="result-card-desktop" className="investment-result-table">
                <tbody>
                    <tr>
                        <td>
                            <div className="calculate-button calculate-desktop">
                                <OmButton
                                    type="primary"
                                    size="large"
                                    text="CALCULATE"
                                    disabled={calculateButtonDisabled}
                                    withIcon={true}
                                    iconName="chevron_right"
                                    onClick={() => setInvestmentResult()}
                                >
                                </OmButton>
                            </div>
                            <Notice />
                        </td>
                        <td>
                            <div className="result-card-desktop-view">
                                {
                                    investmentResult.message ?
                                        <ResultCardView
                                            isMobile={false}
                                            maxInvestmentValue={investmentResult.maxEarnings}
                                            minInvestmentValue={investmentResult.minEarnings}
                                        /> : null
                                }
                                <AssumptionsModal closable={false} open={isAssumptionModalOpen}/>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            {/*    mobile card */}
            <div slot="result-card-mobile" className="mobile-result-card">
                <div className="calculate-button calculate-mobile">
                    <omButton
                        type="primary"
                        size="small"
                        text="CALCULATE"
                        disabled={calculateButtonDisabled}
                        withIcon={true}
                        iconName="chevron_down"
                        onClick={() => setInvestmentResult()}
                    >
                    </omButton>
                </div>
                <Notice/>
                {
                    investmentResult.message ?
                        <ResultCardView
                            isMobile={true}
                            maxInvestmentValue={investmentResult.maxEarnings}
                            minInvestmentValue={investmentResult.minEarnings}
                        /> : null
                }
                <AssumptionsModal closable={false} open={isAssumptionModalOpen}/>
            </div>
        </>
    )
}

export default ResultCardSection;
